<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,3.009999990463257C12,3.009999990463257,4,3.009999990463257,4,3.009999990463257C3.45,3.009999990463257,3,3.459999990463257,3,4.009999990463257C3,4.009999990463257,3,12.009999990463257,3,12.009999990463257C3,12.559999990463258,3.45,13.009999990463257,4,13.009999990463257C4,13.009999990463257,12,13.009999990463257,12,13.009999990463257C12.55,13.009999990463257,13,12.559999990463258,13,12.009999990463257C13,12.009999990463257,13,4.009999990463257,13,4.009999990463257C13,3.449999990463257,12.55,3.009999990463257,12,3.009999990463257C12,3.009999990463257,12,3.009999990463257,12,3.009999990463257Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SymbolSquare',
} as DefineComponent
</script>
